<header
  *ngIf="isMobileView"
  class="vPlaybookHeaderGradient"
  [ngClass]="{ 'translation-context-header': isTranslationModule }"
>
  <div
    *ngIf="isTranslationModule"
    class="translation-header-title"
  >
    Playbook translation
  </div>
  <div class="navbar-brand">
    <img
      *ngIf="isDisplayCompanyLogo; else defaultLogo"
      style="width: 165px; object-fit: scale-down"
      onerror="this.src = 'assets/img/loader.gif';"
      (load)="isDisplayCompanyLogoLoaded = true"
      [hidden]="!isDisplayCompanyLogoLoaded"
      src="{{
        '/api/Assets/Image/' + companyDetail.assetId
          | loadSecureAssets : true
          | async
      }}"
    />
    <ng-template #defaultLogo>
      <img
        src="/assets/img/vPlaybook-logo_color_sm.png"
        style="width: 165px; object-fit: scale-down"
      />
    </ng-template>
    <!-- 
      *ngIf="
        companyId &&
        [
          'SuperVPlaybookAdmin',
          'StandardVPlaybookAdmin',
          'Administrator'
        ].includes(loggedInUserRole)
      "

     -->
    <span
      id="spnCompanySettings"
      class="admin-setting-gear"
      *ngIf="companyId && ['SuperVPlaybookAdmin'].includes(loggedInUserRole)"
      (click)="!disableSettingsBtn && openEditCompnay()"
    >
      <i class="material-icons">settings</i>
    </span>
  </div>
  <a
    class="menu-btn menu"
    (click)="sideBarshow = true"
    [ngClass]="{ hide: sideBarshow }"
    ><i class="material-icons">dehaze</i></a
  >
  <div class="side-navigation-bg" [ngClass]="{ 'sidebar-open': sideBarshow }">
    <ul class="">
      <li *ngIf="sideBarshow">
        <a (click)="sideBarshow = false" [ngClass]="{ show: sideBarshow }">
          <i class="material-icons close-arrow">arrow_forward</i>
        </a>
      </li>

      <!-- Companies -->
      <li
        [ngClass]="{ active: activeModule == 'company' }"
        *ngIf="
          showNavigationItem([
            'SuperVPlaybookAdmin',
            'StandardVPlaybookAdmin',
            'SpecificVPlaybookAdmin',
            'CompanyReader',
            'VPlaybookReader'
          ]) && !isTranslationModule
        "
      >
        <a
          (click)="redirectClearCompanyData($event, 'companies')"
          href="/companies"
          >Companies</a
        >
      </li>

      <!-- Admins -->
      <li
        [ngClass]="{
          active:
            activeModule == 'Admins' ||
            activeModule == 'SearchAll' ||
            activeModule == 'AdminReports' ||
            activeModule == 'AboutUserLevels'
        }"
        *ngIf="
          showNavigationItem(['SuperVPlaybookAdmin']) && !isTranslationModule
        "
      >
        <a (click)="redirectClearCompanyData($event, 'people')" href="/people"
          >Admins</a
        >
      </li>

      <!-- Page Templates -->
      <li
        [ngClass]="{
          active:
            activeModule == 'templates' ||
            activeModule == 'coachingchallenges' ||
            activeModule == 'reportdescriptionTemplate' ||
            activeModule == 'adminteamassessment'
        }"
        *ngIf="
          showNavigationItem(['SuperVPlaybookAdmin']) && !isTranslationModule
        "
      >
        <a
          (click)="redirectClearCompanyData($event, 'templates')"
          href="/templates"
          >Templates</a
        >
      </li>

      <!-- Support -->
      <li
        *ngIf="
          showNavigationItem([
            'StandardVPlaybookAdmin',
            'SpecificVPlaybookAdmin',
            'CompanyReader',
            'VPlaybookReader',
            'Administrator',
            'User',
            'SalesManager',
            'PlaybookOwner'
          ]) && !isTranslationModule
        "
      >
        <a href="mailto:support@vplaybook.com">Support</a>
      </li>

      <!-- v Builder -->
      <li
        [ngClass]="{ active: activeModule == 'VBuilderAdmin' }"
        *ngIf="
          showNavigationItem(['SuperVPlaybookAdmin']) && !isTranslationModule
        "
      >
        <a
          (click)="redirectClearCompanyData($event, 'vbuilder')"
          href="/vbuilder"
          >vBuilder</a
        >
      </li>

      <!-- Back to Playbook-->
      <li
        *ngIf="
          showNavigationItem([
            'SuperVPlaybookAdmin',
            'StandardVPlaybookAdmin',
            'VPlaybookReader',
            'CompanyReader',
            'SpecificVPlaybookAdmin',
            'Administrator',
            'PlaybookOwner',
            'SalesManager',
            'User'
          ]) && isTranslationModule
        "
      >
        <a class="cursor-pointer" (click)="openPlaybookPage()"
          >Back To Playbook Page</a
        >
      </li>

      <!-- User Guide -->
      <li
        *ngIf="
          showNavigationItem([
            'SuperVPlaybookAdmin',
            'StandardVPlaybookAdmin',
            'VPlaybookReader',
            'CompanyReader',
            'SpecificVPlaybookAdmin',
            'Administrator',
            'PlaybookOwner',
            'SalesManager',
            'User'
          ])
        "
      >
        <a class="cursor-pointer" (click)="openUserGuideModal()">User Guide</a>
      </li>

      <!--  Settings -->
      <li
        [ngClass]="{
          active:
            activeModule == 'userguide' ||
            activeModule == 'releasenotifications' ||
            activeModule == 'applicationversion'
        }"
        *ngIf="showNavigationItem(['SuperVPlaybookAdmin'])"
      >
        <a
          (click)="redirectClearCompanyData($event, 'settings')"
          href="/settings"
          >Settings</a
        >
      </li>

      <!-- Profile -->
      <li
        [ngClass]="{ active: activeModule == 'profile' }"
        *ngIf="
          showNavigationItem([
            'SuperVPlaybookAdmin',
            'StandardVPlaybookAdmin',
            'VPlaybookReader',
            'CompanyReader',
            'SpecificVPlaybookAdmin',
            'Administrator',
            'PlaybookOwner',
            'SalesManager',
            'User'
          ])
        "
      >
        <a
          (click)="redirectClearCompanyData($event, 'profile', 'settings')"
          href="/profile/settings"
          >Profile</a
        >
      </li>
      <!-- Logout -->
      <li
        (click)="signOut()"
        class="cursor-pointer"
        *ngIf="
          showNavigationItem([
            'SuperVPlaybookAdmin',
            'StandardVPlaybookAdmin',
            'VPlaybookReader',
            'CompanyReader',
            'SpecificVPlaybookAdmin',
            'Administrator',
            'PlaybookOwner',
            'SalesManager',
            'User'
          ])
        "
      >
        <a>Logout</a>
      </li>
      <!-- Logoff User -->
      <li *ngIf="isLogOffUser" class="logoffuser">
        <a class="cursor-pointer" (click)="logOffUser()">
          Logoff as - {{ logOffUserName }}
        </a>
        <div *ngIf="isLogOffUser" class="loggedinuser-temp">
          (Signed in as {{ logOffUserName }})
        </div>
      </li>
    </ul>
  </div>
</header>

<header
  *ngIf="!isMobileView"
  class="vPlaybookHeaderGradient"
  [ngClass]="{ 'translation-context-header': isTranslationModule }"
>
  <div
    *ngIf="isTranslationModule"
    class="translation-header-title"
  >
    Playbook translation
  </div>
  <div
    class="navbar-brand navigationbar-brand width-230"
    [ngClass]="isMenuCollapsed ? ' width-90' : ' width-230'"
  >
    <ng-container
      *ngIf="
        !companyDetail || (companyDetail && companyDetail.isDefaultLogo);
        else altLogo
      "
    >
      <span *ngIf="!isMenuCollapsed">
        <img
          *ngIf="isDisplayCompanyLogo; else defaultLogo"
          style="width: 165px; object-fit: scale-down"
          onerror="this.src = 'assets/img/loader.gif'"
          (load)="isMenuCollapsedCompanyLogoLoaded = true"
          [hidden]="!isMenuCollapsedCompanyLogoLoaded"
          src="{{
            '/api/Assets/Image/' + companyDetail.assetId
              | loadSecureAssets : true
              | async
          }}"
        />
        <ng-template #defaultLogo>
          <img
            src="/assets/img/vPlaybook-logo_color_sm.png"
            style="width: 165px; object-fit: scale-down"
          />
        </ng-template>
      </span>
      <span *ngIf="isMenuCollapsed">
        <img
          *ngIf="isDisplayCompanyIcon; else defaultIcon"
          class="default-small-icon"
          onerror="this.src = 'assets/img/loader.gif'"
          (load)="isMenuDisplayCompanyIconLoaded = true"
          [hidden]="!isMenuDisplayCompanyIconLoaded"
          src="{{
            '/api/Assets/Image/' +
              companyDetail.iconAssetId +
              '?width=30&height=30'
              | loadSecureAssets : true
              | async
          }}"
        />
        <ng-template #defaultIcon>
          <img src="/assets/img/v_logo.png" class="default-small-icon" />
        </ng-template>
      </span>
    </ng-container>
    <ng-template #altLogo>
      <span *ngIf="!isMenuCollapsed">
        <img
          *ngIf="isAltDisplayCompanyLogo; else altCompanyLogo"
          style="width: 165px; object-fit: scale-down"
          onerror="this.src = 'assets/img/loader.gif'"
          (load)="isAltDisplayCompanyLogoLoaded = true"
          [hidden]="!isAltDisplayCompanyLogoLoaded"
          src="{{
            '/api/Assets/Image/' + companyDetail.altCompanyLogoAssetId
              | loadSecureAssets : true
              | async
          }}"
        />
        <ng-template #altCompanyLogo>
          <img
            src="/assets/img/vPlaybook-logo_color_sm.png"
            style="width: 165px; object-fit: scale-down"
          />
        </ng-template>
      </span>
      <span *ngIf="isMenuCollapsed">
        <img
          *ngIf="isAltDisplayCompanyIcon; else altCompanyIcon"
          class="default-small-icon"
          onerror="this.src = 'assets/img/loader.gif'"
          (load)="isAltDisplayCompanyIconLoaded = true"
          [hidden]="!isAltDisplayCompanyIconLoaded"
          src="{{
            '/api/Assets/Image/' +
              companyDetail.altCompanyIconAssetId +
              '?width=30&height=30'
              | loadSecureAssets : true
              | async
          }}"
        />
        <ng-template #altCompanyIcon>
          <img src="/assets/img/v_logo.png" class="default-small-icon" />
        </ng-template>
      </span>
    </ng-template>
    <div
      class="dynamic-header-design"
      [ngClass]="isMenuCollapsed ? ' left-90' : ' left-180'"
      style="top: 0"
    >
      <span
        id="spnCompanySettings"
        class="admin-setting-gear"
        *ngIf="!isMenuCollapsed && isBothNavigation"
        (click)="toggleMenuBar()"
      >
        <i class="material-icons header-bar-icon">arrow_left</i>
      </span>
      <span
        id="spnCompanySettings"
        class="admin-setting-gear"
        *ngIf="isMenuCollapsed && isBothNavigation"
        (click)="toggleMenuBar()"
      >
        <i class="material-icons header-bar-icon">arrow_right</i>
      </span>
    </div>
    <!-- 
      *ngIf="
        companyId &&
        [
          'SuperVPlaybookAdmin',
          'StandardVPlaybookAdmin',
          'Administrator'
        ].includes(loggedInUserRole) &&
        !isMenuCollapsed
      "
     -->
    <span
      id="spnCompanySettings"
      class="admin-setting-gear"
      style="margin-left: 40px"
      *ngIf="
        companyId &&
        ['SuperVPlaybookAdmin', 'Administrator'].includes(loggedInUserRole) &&
        !isMenuCollapsed
      "
      (click)="!disableSettingsBtn && openEditCompnay()"
    >
      <i class="material-icons header-bar-icon">settings</i>
    </span>
  </div>

  <a
    class="menu-btn menu"
    (click)="sideBarshow = true"
    [ngClass]="{ hide: sideBarshow }"
    ><i class="material-icons">dehaze</i></a
  >
  <div class="side-navigation-bg" [ngClass]="{ 'sidebar-open': sideBarshow }">
    <ul *ngIf="sideBarshow">
      <li>
        <a (click)="sideBarshow = false" [ngClass]="{ show: sideBarshow }">
          <i class="material-icons close-arrow">arrow_forward</i>
        </a>
      </li>

      <!-- Companies -->
      <li
        [ngClass]="{ active: activeModule == 'company' }"
        *ngIf="
          showNavigationItem([
            'SuperVPlaybookAdmin',
            'StandardVPlaybookAdmin',
            'SpecificVPlaybookAdmin',
            'CompanyReader',
            'VPlaybookReader'
          ]) && !isTranslationModule
        "
      >
        <a
          (click)="redirectClearCompanyData($event, 'companies')"
          href="/companies"
          >Companies</a
        >
      </li>

      <!-- Admins -->
      <li
        [ngClass]="{
          active:
            activeModule == 'Admins' ||
            activeModule == 'SearchAll' ||
            activeModule == 'AdminReports' ||
            activeModule == 'AboutUserLevels'
        }"
        *ngIf="
          showNavigationItem(['SuperVPlaybookAdmin']) && !isTranslationModule
        "
      >
        <a (click)="redirectClearCompanyData($event, 'people')" href="/people"
          >Admins</a
        >
      </li>

      <!-- Page Templates -->
      <li
        [ngClass]="{
          active:
            activeModule == 'templates' ||
            activeModule == 'coachingchallenges' ||
            activeModule == 'reportdescriptionTemplate' ||
            activeModule == 'adminteamassessment'
        }"
        *ngIf="
          showNavigationItem(['SuperVPlaybookAdmin']) && !isTranslationModule
        "
      >
        <a
          (click)="redirectClearCompanyData($event, 'templates')"
          href="/templates"
          >Templates</a
        >
      </li>

      <!-- Support -->
      <li
        *ngIf="
          showNavigationItem([
            'StandardVPlaybookAdmin',
            'SpecificVPlaybookAdmin',
            'CompanyReader',
            'VPlaybookReader',
            'Administrator',
            'User',
            'SalesManager',
            'PlaybookOwner'
          ]) && !isTranslationModule
        "
      >
        <a href="mailto:support@vplaybook.com">Support</a>
      </li>

      <!-- v Builder -->
      <li
        [ngClass]="{ active: activeModule == 'VBuilderAdmin' }"
        *ngIf="
          showNavigationItem(['SuperVPlaybookAdmin']) && !isTranslationModule
        "
      >
        <a
          (click)="redirectClearCompanyData($event, 'vbuilder')"
          href="/vbuilder"
          >vBuilder</a
        >
      </li>

      <!-- Back to Playbook-->
      <li
        *ngIf="
          showNavigationItem([
            'SuperVPlaybookAdmin',
            'StandardVPlaybookAdmin',
            'VPlaybookReader',
            'CompanyReader',
            'SpecificVPlaybookAdmin',
            'Administrator',
            'PlaybookOwner',
            'SalesManager',
            'User'
          ]) && isTranslationModule
        "
      >
        <a class="cursor-pointer" (click)="openPlaybookPage()"
          >Back To Playbook Page</a
        >
      </li>

      <!-- User Guide -->
      <li
        *ngIf="
          showNavigationItem([
            'SuperVPlaybookAdmin',
            'StandardVPlaybookAdmin',
            'VPlaybookReader',
            'CompanyReader',
            'SpecificVPlaybookAdmin',
            'Administrator',
            'PlaybookOwner',
            'SalesManager',
            'User'
          ])
        "
      >
        <a class="cursor-pointer" (click)="openUserGuideModal()">User Guide</a>
      </li>

      <!--  Settings -->
      <li
        [ngClass]="{
          active:
            activeModule == 'userguide' ||
            activeModule == 'releasenotifications' ||
            activeModule == 'applicationversion'
        }"
        *ngIf="showNavigationItem(['SuperVPlaybookAdmin'])"
      >
        <a
          (click)="redirectClearCompanyData($event, 'settings')"
          href="/settings"
          >Settings</a
        >
      </li>

      <!-- Profile -->
      <li
        [ngClass]="{ active: activeModule == 'profile' }"
        *ngIf="
          showNavigationItem([
            'SuperVPlaybookAdmin',
            'StandardVPlaybookAdmin',
            'VPlaybookReader',
            'CompanyReader',
            'SpecificVPlaybookAdmin',
            'Administrator',
            'PlaybookOwner',
            'SalesManager',
            'User'
          ])
        "
      >
        <a
          (click)="redirectClearCompanyData($event, 'profile', 'settings')"
          href="/profile/settings"
          >Profile</a
        >
      </li>
      <!-- Logout -->
      <li
        (click)="signOut()"
        class="cursor-pointer"
        *ngIf="
          showNavigationItem([
            'SuperVPlaybookAdmin',
            'StandardVPlaybookAdmin',
            'VPlaybookReader',
            'CompanyReader',
            'SpecificVPlaybookAdmin',
            'Administrator',
            'PlaybookOwner',
            'SalesManager',
            'User'
          ])
        "
      >
        <a>Logout</a>
      </li>
      <!-- Logoff User -->
      <li *ngIf="isLogOffUser" class="logoffuser">
        <a class="cursor-pointer" (click)="logOffUser()">
          Logoff as - {{ logOffUserName }}
        </a>
        <div *ngIf="isLogOffUser" class="loggedinuser-temp">
          (Signed in as {{ logOffUserName }})
        </div>
      </li>
    </ul>

    <ul *ngIf="!sideBarshow" class="navbar-nav me-auto">
      <li class="nav-item">
        <!-- User Guide -->
        <a
          *ngIf="
            showNavigationItem([
              'SuperVPlaybookAdmin',
              'StandardVPlaybookAdmin',
              'VPlaybookReader',
              'CompanyReader',
              'SpecificVPlaybookAdmin',
              'Administrator',
              'PlaybookOwner',
              'SalesManager',
              'User'
            ])
          "
          class="nav-link cursor-pointer"
          (click)="openUserGuideModal()"
        >
          <span class="material-icons align-middle header-bar-icon">
            help
          </span>
        </a>
      </li>

      <!-- Other menus -->
      <li class="nav-item dropdown">
        <a
          class="nav-link dropdown-toggle header-bar-icon"
          href="#"
          id="navbarDropdown"
          role="button"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span class="material-icons align-middle header-bar-icon">
            description
          </span>
        </a>

        <div
          class="dropdown-menu dropdown-style"
          aria-labelledby="navbarDropdown"
        >
          <!-- Companies -->
          <a
            [ngClass]="{ active: activeModule == 'company' }"
            *ngIf="
              showNavigationItem([
                'SuperVPlaybookAdmin',
                'StandardVPlaybookAdmin',
                'SpecificVPlaybookAdmin',
                'CompanyReader',
                'VPlaybookReader'
              ]) && !isTranslationModule
            "
            (click)="redirectClearCompanyData($event, 'companies')"
            href="/companies"
            class="dropdown-item"
          >
            Companies
          </a>

          <!-- Admins -->
          <a
            [ngClass]="{
              active:
                activeModule == 'Admins' ||
                activeModule == 'SearchAll' ||
                activeModule == 'AdminReports' ||
                activeModule == 'AboutUserLevels'
            }"
            *ngIf="
              showNavigationItem(['SuperVPlaybookAdmin']) &&
              !isTranslationModule
            "
            (click)="redirectClearCompanyData($event, 'people')"
            href="/people"
            class="dropdown-item"
          >
            Admins
          </a>

          <!-- Page Templates -->
          <a
            [ngClass]="{
              active:
                activeModule == 'templates' ||
                activeModule == 'coachingchallenges' ||
                activeModule == 'reportdescriptionTemplate' ||
                activeModule == 'adminteamassessment'
            }"
            *ngIf="
              showNavigationItem(['SuperVPlaybookAdmin']) &&
              !isTranslationModule
            "
            (click)="redirectClearCompanyData($event, 'templates')"
            href="/templates"
            class="dropdown-item"
          >
            Templates
          </a>

          <!-- Support -->
          <a
            *ngIf="
              showNavigationItem([
                'StandardVPlaybookAdmin',
                'SpecificVPlaybookAdmin',
                'CompanyReader',
                'VPlaybookReader',
                'Administrator',
                'User',
                'SalesManager',
                'PlaybookOwner'
              ]) && !isTranslationModule
            "
            href="mailto:support@vplaybook.com"
            class="dropdown-item"
          >
            Support
          </a>

          <!-- v Builder -->
          <a
            [ngClass]="{ active: activeModule == 'VBuilderAdmin' }"
            *ngIf="
              showNavigationItem(['SuperVPlaybookAdmin']) &&
              !isTranslationModule
            "
            (click)="redirectClearCompanyData($event, 'vbuilder')"
            href="/vbuilder"
            class="dropdown-item"
          >
            vBuilder
          </a>

          <!-- Back to Playbook-->
          <a
            *ngIf="
              showNavigationItem([
                'SuperVPlaybookAdmin',
                'StandardVPlaybookAdmin',
                'VPlaybookReader',
                'CompanyReader',
                'SpecificVPlaybookAdmin',
                'Administrator',
                'PlaybookOwner',
                'SalesManager',
                'User'
              ]) && isTranslationModule
            "
            class="cursor-pointer"
            (click)="openPlaybookPage()"
            class="dropdown-item"
          >
            Back To Playbook Page
          </a>

          <!--  Settings -->
          <a
            [ngClass]="{
              active:
                activeModule == 'userguide' ||
                activeModule == 'releasenotifications' ||
                activeModule == 'applicationversion'
            }"
            *ngIf="showNavigationItem(['SuperVPlaybookAdmin'])"
            (click)="redirectClearCompanyData($event, 'settings')"
            href="/settings"
            class="dropdown-item"
          >
            Settings
          </a>
        </div>
      </li>

      <!-- profile -->
      <li class="nav-item dropdown">
        <a
          class="nav-link dropdown-toggle header-bar-icon"
          href="#"
          id="navbarDropdownMenuLink"
          role="button"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span
            class="material-icons"
            *ngIf="!profileAssetId"
            style="vertical-align: middle"
          >
            account_circle
          </span>
          <img
            *ngIf="profileAssetId"
            [src]="
              '/api/Assets/Image/' + profileAssetId
                | loadSecureAssets : true
                | async
            "
            width="40"
            height="40"
            class="rounded-circle"
            alt="Profile"
            title="Profile"
            onerror="this.src = 'assets/img/loader.gif';"
            (load)="isProfileLoaded = true"
            [hidden]="!isProfileLoaded"
          />
        </a>
        <div
          class="dropdown-menu dropdown-style"
          aria-labelledby="navbarDropdownMenuLink"
        >
          <a
            [ngClass]="{ active: activeModule == 'profile' }"
            *ngIf="
              showNavigationItem([
                'SuperVPlaybookAdmin',
                'StandardVPlaybookAdmin',
                'VPlaybookReader',
                'CompanyReader',
                'SpecificVPlaybookAdmin',
                'Administrator',
                'PlaybookOwner',
                'SalesManager',
                'User'
              ])
            "
            (click)="redirectClearCompanyData($event, 'profile', 'settings')"
            href="/profile/settings"
            class="dropdown-item"
          >
            Profile
          </a>
          <!-- Logout -->
          <a
            (click)="signOut()"
            class="cursor-pointer dropdown-item"
            *ngIf="
              showNavigationItem([
                'SuperVPlaybookAdmin',
                'StandardVPlaybookAdmin',
                'VPlaybookReader',
                'CompanyReader',
                'SpecificVPlaybookAdmin',
                'Administrator',
                'PlaybookOwner',
                'SalesManager',
                'User'
              ])
            "
          >
            Logout
          </a>
          <!-- Logoff User -->
          <a
            *ngIf="isLogOffUser"
            class="logoffuser dropdown-item"
            (click)="logOffUser()"
          >
            <a class="cursor-pointer" style="padding: 0px">
              Logoff as - {{ logOffUserName }}
            </a>
            <div
              *ngIf="isLogOffUser"
              class="loggedinuser-temp"
              style="margin-top: -11px"
            >
              (Signed in as {{ logOffUserName }})
            </div>
          </a>
        </div>
      </li>
    </ul>
  </div>
</header>
<!--Header-END-->
